module.exports = __webpack_public_path__ + "img/picture_viptk.ae1f12fc.png";